export default "__VITE_ASSET__CIvajLEE__"